import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-down-time',
  templateUrl: './down-time.component.html',
  styleUrls: ['./down-time.component.css']
})
export class DownTimeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
